import {FunnelKey} from "./Keys";
import {Property} from "csstype";
import {VisibleCell, VisibleCellInfo} from "./VisibleCell";

export class FunnelGroupCell {

    private readonly key: FunnelKey;
    private readonly name: string;

    constructor(key: FunnelKey, name: string) {
        this.key = key;
        this.name = name;
    }

    get Key(): FunnelKey {
        return this.key;
    }

    get Name(): string {
        return this.name;
    }

    get OstensibleName(): string {
        return VisibleCell.getOstensibleValue(this.name);
    }
}


type VisibleFunnelGroupCellState = {
    GridColumn: string;
    IsSelected: boolean;
    BackgroundColor: Property.BackgroundColor;
    PrevFunnelKeyOrNull: FunnelKey | null;
    NextFunnelKeyOrNull: FunnelKey | null;
    IsJoinable: boolean;
    IsSeparatable: boolean;
    JoinedKeys: FunnelKey[];
    Collaborators: string[];
}

export class VisibleFunnelGroupCell extends FunnelGroupCell {

    private readonly state: VisibleFunnelGroupCellState;

    constructor(funnel_group_cell: FunnelGroupCell, state: VisibleFunnelGroupCellState) {
        super(funnel_group_cell.Key, funnel_group_cell.Name);
        this.state = state;
    }

    get State(): VisibleFunnelGroupCellState {
        return this.state;
    }

    isChangeableName(name: string) {
        return VisibleCell.isChangeableValue(this.Name, name);
    }
}

export class FunnelGroupLine {
    private cells: VisibleFunnelGroupCell[];

    constructor(funnel_group_cells: VisibleFunnelGroupCell[]) {
        this.cells = funnel_group_cells;
    }

    mapCells<U>(callbackfn: (cell: VisibleFunnelGroupCell, index: number, array: VisibleFunnelGroupCell[]) => U): U[] {
        return this.cells.map(callbackfn);
    }

    getSelectedCellOrNull(): VisibleFunnelGroupCell | null {
        return this.cells.find(c => c.State.IsSelected) ?? null;
    }

    static makeVisibleCells(base_cells: FunnelGroupCell[], merge: boolean,
                            callckabfn: (v: VisibleCellInfo<FunnelGroupCell>) => VisibleFunnelGroupCell)
        : VisibleFunnelGroupCell[] {

        return VisibleCell.makeVisibleCellList(base_cells).filter(
            v => (!merge || 0 < v.keys.length)
        ).map(
            v => callckabfn(v)
        );
    }

}
